import { jsx as _jsx } from "react/jsx-runtime";
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIBadge from 'UIComponents/badge/UIBadge';
import { useSelector } from 'react-redux'; // import { isUngatedForStarterGWPSelector } from '../../selectors/GatingSelectors';

import { isStarterGWP2023EligibleSelector } from '../../selectors/PromotionSelectors';

const BestValueBadge = ({
  className,
  message = 'bestValue',
  isEbx633
}) => {
  const isEligibleForStarterGWPPromotion = useSelector(isStarterGWP2023EligibleSelector); // const isUngatedForGWP = useSelector(isUngatedForStarterGWPSelector);

  const isGWP = isEligibleForStarterGWPPromotion && !isEbx633; // && isUngatedForGWP;

  return /*#__PURE__*/_jsx(UIBadge, {
    use: "new",
    className: className,
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: isGWP ? 'badges.newCustomerOffer' : `badges.${message}`
    })
  });
};

export default BestValueBadge;